import { Button } from 'components/core';
import { FC } from 'react';
import {
  Styled,
  OrderConfirmationProps,
  isCartContainsCustomizedItems,
  isCartContainsItemsWithExpiration,
} from './';
import { useI18n } from 'contexts/i18n';
import { useRetriveCart } from 'reactQuery/queries';
import { useReadOnlyUser } from 'utils/hooks';

export const OrderInfoConfirmation: FC<OrderConfirmationProps> = ({
  onPlaceOrder,
  isLoading,
  isAcceptedBrandGuildlines,
  isAcceptedUsageGuildlines,
}) => {
  const i18n = useI18n();
  const { data: cart } = useRetriveCart();
  const { isReadOnlyUser } = useReadOnlyUser();

  const isCartHavingCustomizedItems = isCartContainsCustomizedItems(
    cart?.lineItems || []
  );
  const isCartHavingItemsWithExpiration = isCartContainsItemsWithExpiration(
    cart?.lineItems || []
  );
  return (
    <Styled.OrderInfoConfirmationContainer>
      <Styled.Heading>
        {i18n['Is all your information correct?']}
      </Styled.Heading>
      <Styled.OrderInfoConfirmation>
        <Styled.Message>
          {
            i18n[
              'Before you place your order, please take a moment to review your shipping information, billing information, and order summary.'
            ]
          }
        </Styled.Message>
        <Button
          size="lg"
          onClick={onPlaceOrder}
          disabled={
            isLoading ||
            isReadOnlyUser ||
            (isCartHavingCustomizedItems && !isAcceptedBrandGuildlines) ||
            (isCartHavingItemsWithExpiration && !isAcceptedUsageGuildlines)
          }
        >
          {i18n['Place Order']}
        </Button>
      </Styled.OrderInfoConfirmation>
    </Styled.OrderInfoConfirmationContainer>
  );
};
